import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn, LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Button } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)``;

export const Description = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
`;

export const InputContainer = styled(LeftFlexRow)`
    gap: 8px;
`;

export const ErrorText = styled.div`
    margin-top: 8px;
    ${setFontVariant("listItem3", colorsPalettes.red[500])};
`;

export const InviteButton = styled(Button)`
    min-width: 71px;
`;

export const InvitationsStatusButton = styled(Button)`
    padding: 0 15px;
`;
